module.exports = __webpack_public_path__ + "img/fondo-banner-principal.d178e34a.svg";